export default "__VITE_ASSET__9e57b148__"